import React from 'react';
import { motion } from 'framer-motion';
const scheduleData = [{
  time: '04:00',
  events: [{
    title: 'Logistics Setup',
    station: 'Parking & Logistics',
    filled: '15/18',
    duration: 2
  }]
}, {
  time: '05:30',
  events: [{
    title: 'Medical Briefing',
    station: 'Finish Line Medical',
    filled: '8/8',
    duration: 1.5
  }]
}, {
  time: '06:00',
  events: [{
    title: 'Water Station Prep',
    station: 'Water Station 1',
    filled: '12/12',
    duration: 4
  }]
}, {
  time: '06:30',
  events: [{
    title: 'Marshal Deployment',
    station: 'Route Marshal Zone A',
    filled: '40/40',
    duration: 6
  }]
}, {
  time: '07:00',
  events: [{
    title: 'Media Check-in',
    station: 'Media Tent',
    filled: '4/4',
    duration: 8
  }]
}];
export function Schedule() {
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} className="space-y-6" data-id="element-576">
      <div data-id="element-577">
        <h1 className="text-2xl font-display font-bold text-white mb-1" data-id="element-578">
          Schedule
        </h1>
        <p className="text-[var(--muted)] text-sm" data-id="element-579">
          Event day timeline and shift coverage.
        </p>
      </div>

      <div className="bg-[var(--surface)] border border-white/5 rounded-xl p-6" data-id="element-580">
        <div className="relative border-l border-white/10 ml-4 space-y-8 pb-4" data-id="element-581">
          {scheduleData.map((slot, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: i * 0.1
        }} className="relative pl-8" data-id="element-582">
              {/* Timeline dot */}
              <div className="absolute -left-1.5 top-1.5 w-3 h-3 rounded-full bg-[var(--surface)] border-2 border-[var(--accent)]" data-id="element-583" />

              <div className="flex flex-col sm:flex-row sm:items-start gap-4" data-id="element-584">
                <div className="w-20 shrink-0" data-id="element-585">
                  <span className="text-sm font-bold text-white" data-id="element-586">
                    {slot.time}
                  </span>
                </div>

                <div className="flex-1 space-y-3" data-id="element-587">
                  {slot.events.map((event, j) => <div key={j} className="bg-white/[0.02] border border-white/5 rounded-lg p-4 hover:border-white/10 transition-colors" data-id="element-588">
                      <div className="flex justify-between items-start mb-2" data-id="element-589">
                        <div data-id="element-590">
                          <h4 className="text-white font-medium" data-id="element-591">
                            {event.title}
                          </h4>
                          <p className="text-[var(--muted)] text-sm" data-id="element-592">
                            {event.station}
                          </p>
                        </div>
                        <span className={`text-xs font-medium px-2 py-1 rounded-md ${event.filled.split('/')[0] === event.filled.split('/')[1] ? 'bg-[var(--success)]/10 text-[var(--success)]' : 'bg-orange-400/10 text-orange-400'}`} data-id="element-593">
                          {event.filled} Filled
                        </span>
                      </div>
                      <div className="w-full bg-white/5 rounded-full h-1.5 mt-3 overflow-hidden" data-id="element-594">
                        <div className={`h-full rounded-full ${event.filled.split('/')[0] === event.filled.split('/')[1] ? 'bg-[var(--success)]' : 'bg-orange-400'}`} style={{
                    width: `${parseInt(event.filled.split('/')[0]) / parseInt(event.filled.split('/')[1]) * 100}%`
                  }} data-id="element-595" />
                      </div>
                    </div>)}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </motion.div>;
}